import { useEffect, useState } from "react";
import DataTable from "../DataTable/DataTable";

const ErrorPage = (props: any) => {
  const { DMSType } = props;

  const [data, SetData] = useState([] as any);
  const [dealerId, SetDealerId] = useState("");
  const [errorMessage, SetErrorMessage] = useState("");
  const [stackTrace, SetStackTrace] = useState("");
  const [env, SetEnv] = useState("");
  const [note, SetNote] = useState("");
  const [search, SetSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [currentPageNumber, SetCurrentPageNuber] = useState(0);
  const [rowsCount, SetRowsCount] = useState(0);

  useEffect(() => {
    GetErrorsData();
  }, [search, rowsPerPage, currentPageNumber]);

  // ------------------------- Fetching Data -----------------------------//
  const GetErrorsData = () => {
    let _dealerId = parseInt(dealerId);
    let obj: any = new Object();

    obj.DealerId = _dealerId > 0 ? _dealerId : 0;
    obj.DMSType = DMSType; // specify DMS Type here
    obj.ErrorMessage = errorMessage;
    obj.StackTrace = stackTrace;
    obj.Env = env;
    obj.Note = note;
    obj.PageSize = rowsPerPage;
    obj.PageNumber = currentPageNumber;

    let jsonString = JSON.stringify(obj);
    let url = `http://infinitylogging.csidealer.com:5111/api/Error/${jsonString}?token=Y29uc3RlbGxhdGlvbjpDMG5zdGVsbEB0aW9u`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => (SetData(data), ResetTotalRows(data)))
      .catch((error) => alert("Error: " + error));
  };

  // --------------------------- HANDLERS -------------------------------//
  const ResetTotalRows = (data: any) => {
    if (currentPageNumber == 0) {
      if (data.length == 0) SetRowsCount(0);
      if (data.length > 0) SetRowsCount(data[0].RowsCount);
    }
  };

  return (
    <>
      <DataTable
        data={data}
        SetSearch={SetSearch}
        dealerId={dealerId}
        SetDealerId={SetDealerId}
        errorMessage={errorMessage}
        SetErrorMessage={SetErrorMessage}
        stackTrace={stackTrace}
        SetStackTrace={SetStackTrace}
        env={env}
        SetEnv={SetEnv}
        note={note}
        SetNote={SetNote}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        currentPageNumber={currentPageNumber}
        SetCurrentPageNuber={SetCurrentPageNuber}
        rowsCount={rowsCount}
      />
    </>
  );
};

export default ErrorPage;
